import { useEffect, useRef, useState } from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

// Local-state + debounced commit so typing stays smooth on live-synced fields
// (avoids the cursor jumping / characters dropping when the value round-trips
// through the shared team state).
export default function DebouncedField({ as = "input", value = "", onCommit, delay = 400, ...props }) {
  const [v, setV] = useState(value);
  const ref = useRef(null);
  const timer = useRef(null);

  useEffect(() => {
    if (document.activeElement !== ref.current) setV(value);
  }, [value]);

  const change = (e) => {
    const nv = e.target.value;
    setV(nv);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => onCommit(nv), delay);
  };
  const flush = () => {
    clearTimeout(timer.current);
    if (v !== value) onCommit(v);
  };

  const Comp = as === "textarea" ? Textarea : Input;
  return <Comp ref={ref} value={v} onChange={change} onBlur={flush} {...props} />;
}
